import { W as WuiTab$1, d as defineCustomElement$1 } from './p-2hU8vSm9.js';

const WuiTab = WuiTab$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTab, defineCustomElement };
